import { Injectable } from '@angular/core';
import { setPreferredScaleSet } from '@epicuro-next/state/user-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { distinctUntilKeyChanged, map } from 'rxjs/operators';

import * as configStripActions from '../actions/index';

/**
 * Effective config strip side-effects
 */
@Injectable()
export class ConfigStripScaleSetEffects {
  public selectScale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(configStripActions.selectScale),
      distinctUntilKeyChanged('scale'),
      map(({ scale }) => {
        return setPreferredScaleSet({ scaleSetId: scale });
      }),
    ),
  );

  /** Dependencies */
  constructor(private actions$: Actions) {}
}
